import connectFormikField from '../connectFormikField/connectFormikField'
import DatePicker from '@/redesign/components/DatePicker/DatePicker'

const FormikDatePicker = connectFormikField(DatePicker)

export default FormikDatePicker
